import axios from 'axios';
import { getServerError } from '../error/error-service';
import { IReportFile } from './print-report-service.types';

const PrintReportApiUrl = `/print-report-api/api`

export const printShiftDailyTask = (shiftTaskIds: number[] | null) => {
    return axios.post<IReportFile>(`${PrintReportApiUrl}/report/ShiftDailyTask`, { ...shiftTaskIds }, { responseType: 'blob' })
        .then((response) => {
            const result: IReportFile =
            {
                file: response.data,
                type: response.headers['content-type'],
            }
            return result;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}

export const printReportFile = (requestData: any, reportName: string) => {
    return axios.post<IReportFile>(`${PrintReportApiUrl}/report/${reportName}`, { ...requestData }, { responseType: 'blob' })
        .then((response) => {
            const result: IReportFile =
            {
                file: response.data,
                type: response.headers['content-type'],
            }
            return result;
        })
        .catch((error) => {
            throw getServerError(error);
        });
}












